// src/contexts/ToolConfirmationProvider.tsx
"use client";

import React, { ReactNode } from 'react';
import { ToolStateProvider } from './ToolStateContext';
import { ToolActionsProvider } from './ToolActionsContext';

interface ToolConfirmationProviderProps {
  children: ReactNode;
}

/**
 * Level 3: Tool Confirmation Context
 * Combines tool state management with tool confirmation actions
 * Handles all tool confirmation workflow and UI state
 */
export const ToolConfirmationProvider: React.FC<ToolConfirmationProviderProps> = ({
  children
}) => {
  return (
    <ToolStateProvider>
      <ToolActionsProvider>
        {children}
      </ToolActionsProvider>
    </ToolStateProvider>
  );
};